/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_filters__select_to_filter = /** @type {(inputs: {}) => string} */ () => {
	return `die entsprechenden Filter anzeigen.`
};

const en_poi_filters__select_to_filter = /** @type {(inputs: {}) => string} */ () => {
	return `display the corresponding filters.`
};

const es_poi_filters__select_to_filter = /** @type {(inputs: {}) => string} */ () => {
	return `mostrar los filtros correspondientes.`
};

const fr_poi_filters__select_to_filter = /** @type {(inputs: {}) => string} */ () => {
	return `afficher les filtres correspondants.`
};

const it_poi_filters__select_to_filter = /** @type {(inputs: {}) => string} */ () => {
	return `visualizzare i filtri corrispondenti.`
};

const nl_poi_filters__select_to_filter = /** @type {(inputs: {}) => string} */ () => {
	return `de overeenkomstige filters weergeven.`
};

const pt_poi_filters__select_to_filter = /** @type {(inputs: {}) => string} */ () => {
	return `apresentam os filtros correspondentes.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__select_to_filter = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_filters__select_to_filter(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_filters__select_to_filter", locale)
	if (locale === "de") return de_poi_filters__select_to_filter(inputs)
	if (locale === "en") return en_poi_filters__select_to_filter(inputs)
	if (locale === "es") return es_poi_filters__select_to_filter(inputs)
	if (locale === "fr") return fr_poi_filters__select_to_filter(inputs)
	if (locale === "it") return it_poi_filters__select_to_filter(inputs)
	if (locale === "nl") return nl_poi_filters__select_to_filter(inputs)
	return pt_poi_filters__select_to_filter(inputs)
};